const store = {
    namespaced: true,
    state: {
        users: [],
        ready: false,
    },
    actions: {
        async search({commit}, data) {
            commit("setReady", false);
            let url = `/user`;
            let params = ['username', 'email', 'fullName', 'role', 'status']
            params = params.map(x => data[x] ? x + '=' + encodeURIComponent(data[x]) : null).filter(x => x);

            if (params.length == 0) {
                commit("setUsers", []);
            } else {
                if(params.length > 0) url = url + '?' + params.join('&');
                let resultFind = await romeApi.get(url, { pageSize: 50 });
                commit("setUsers", resultFind);
            }
            commit("setReady", true);
        },
        async unlock({state}, data) {
            let user = state.users.find(x => x.userId == data.userId);
            await romeApi.post(`user/${data.userId}/unlock`);
            user.isLockedOut = false;
        },
        async clear({commit}) {
            commit("setUsers", []);
        },
        async update({commit}, data){
            commit("setUser", data)
        },
    },
    mutations: {
        setUser(state, value) {
            let userIndex = state.users.findIndex(x => x.userId == value.userId);
            state.users[userIndex] = value;
            state.users = [...state.users];
            //Vue.set(state.users, userIndex, value);
        },
        setReady(state, value) {
            state.ready = value;
        },
        setUsers(state, users) {
            state.users = users
        },
    }
  };
  
  export default store;
  


// WEBPACK FOOTER //
// ./src/user/x-users.js